import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import CurrentTxnListUI from '../../../components/superUser/nodalTxn/CurrentTxnListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const CurrentTxnListPageUI = ({ context, errorList, accountNumber, transactionList, filteredTransactionList,
  selectedTxnId, details, onDetailsClick,
  year, month, yearList, monthList, onYearChange, onMonthChange,
  searchFilter, onSearchFilterChange, onRefreshClick,
  onCopyToClipboard, copyToClipboardText, onExternalClick, failSubmitted,
  onUpdateRemarksClick, updateRemarksMode, onCancelRemarksClick, objectCode, objectId, selectedRemarks,
  transactionId, reconciliationStatus, climeTxnTypeList, txnSent, onSendToZybraClick,
  zybraCustomerList, customerUpdateMode, onCustomerTxnClick, onCustomerTxnCancelClick,
  onDownloadClick
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_txn_l' topnav='transactions'
    headerText='Current Account' centered={!transactionList && !errorList} page='4412' dimension='w768'
  >
    {
      !transactionList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      transactionList &&
      <CurrentTxnListUI context={context}
        accountNumber={accountNumber}
        transactionList={filteredTransactionList}
        onRefreshClick={onRefreshClick}
        yearList={yearList}
        monthList={monthList}
        year={year}
        month={month}
        onYearChange={onYearChange}
        onMonthChange={onMonthChange}
        selectedTxnId={selectedTxnId}
        searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        onExternalClick={onExternalClick}
        failSubmitted={failSubmitted}
        onUpdateRemarksClick={onUpdateRemarksClick}
        updateRemarksMode={updateRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectCode={objectCode}
        objectId={objectId}
        selectedRemarks={selectedRemarks}
        transactionId={transactionId}
        reconciliationStatus={reconciliationStatus}
        climeTxnTypeList={climeTxnTypeList}
        txnSent={txnSent} onSendToZybraClick={onSendToZybraClick}
        details={details} onDetailsClick={onDetailsClick}
        //
        zybraCustomerList={zybraCustomerList}
        customerUpdateMode={customerUpdateMode}
        onCustomerTxnClick={onCustomerTxnClick}
        onCustomerTxnCancelClick={onCustomerTxnCancelClick}
        onDownloadClick={onDownloadClick}
      />
    }
  </SuperUserTxnPageUI>

export default CurrentTxnListPageUI
